import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router'
import { skin, getSearchTerm } from 'Utils'
import sortBy from 'lodash/sortBy'
import { Breadcrumbs, Dialog, CategorySlider, SearchForm } from 'Blocks'
import ProductList from '../../ProductList'
import { Search, FilterButton } from '../components'
import skins from '../skins'

const Small = props => {
  const { dialog, closeDialog, className, location, data } = props
  const isSearch = props.match.params.subCategory === 'search'
  const { activeView: activeDialogView, isActive: isDialogOpen } = dialog
  const { search: queryString } = location
  const term = getSearchTerm({ location })

  const breadCrumbsProps = {
    className: 'breadcrumbs',
    gaEventContext: isSearch ? 'search' : 'category'
  }

  const orderedCategories = sortBy(data.products.categories.children, 'name')

  const heading = (() => {
    if (isSearch && data.products.length === 0) {
      return `Nothing found for: ${term}`
    } else if (isSearch) {
      return `Search: ${term}`
    } else {
      return data.products.categories.current.name
    }
  })()

  return (
    <div className={`${className}${isDialogOpen ? ' no-scroll' : ''}`}>
      <Dialog shouldRender={isDialogOpen} activeView={activeDialogView}>
        {isDialogOpen && activeDialogView === 'search' && (
          <Search {...{ closeDialog }} />
        )}
      </Dialog>
      <div className="topbar">
        <SearchForm
          className="topbar-search"
          showSubmitButton={true}
          showSubmitButtonIcon={true}
          term={term}
        />
        <Breadcrumbs {...breadCrumbsProps} />
      </div>
      <h1 className="heading">{heading}</h1>
      <CategorySlider
        className="category-slider"
        {...{ isSearch }}
        subCategories={orderedCategories}
      />
      <FilterButton queryString={queryString} />
      <ProductList {...props} {...data} />
    </div>
  )
}

Small.propTypes = {
  className: PropTypes.string,
  closeDialog: PropTypes.any,
  data: PropTypes.shape({
    products: PropTypes.shape({
      categories: PropTypes.shape({
        children: PropTypes.any,
        current: PropTypes.shape({
          name: PropTypes.any
        })
      }),
      length: PropTypes.number
    })
  }),
  dialog: PropTypes.shape({
    activeView: PropTypes.string,
    isActive: PropTypes.any
  }),
  location: PropTypes.shape({
    search: PropTypes.any
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      subCategory: PropTypes.string
    })
  })
}

export default withRouter(skin(Small, skins))
